import React from 'react';
import { Box, Body, Heading, BoxProps } from '@hover/blueprint';
import { IProjectVision } from '../../../interfaces/IProjectVision';

interface Props extends BoxProps {
  projectVision: IProjectVision;
  reverse?: boolean;
}

const ProjectVision: React.FC<Props> = ({
  projectVision,
  reverse,
  ...restProps
}) => (
  <Box
    px={200}
    justifyContent={reverse ? 'flex-end' : 'space-between'}
    w="100%"
    alignItems="center"
    flexDir={{
      base: 'column',
      desktop: reverse ? 'row-reverse' : 'row',
    }}
    {...restProps}
  >
    <Box
      flexDir="column"
      alignItems="flex-start"
      maxW="480px"
      mb={{ base: 500, desktop: 0 }}
      ml={{ base: 0, desktop: reverse ? 1100 : 0 }}
    >
      <Body color="red.300" mb={200} size={200} isBold>
        {projectVision.title.toUpperCase()}
      </Body>
      <Heading
        marginBottom={{ base: 500, desktop: 200 }}
        size={{ base: 500, desktop: 600 }}
        fontWeight={{ base: 600, desktop: 600 }}
      >
        {projectVision.header}
      </Heading>
      <Heading marginBottom={500} isDisplay size={200}>
        {projectVision.body}
      </Heading>
      <Heading marginBottom={200} isDisplay size={200}>
        {projectVision.secondBody}
      </Heading>
    </Box>
    <Box maxW="530" justifyContent="center">
      {projectVision.image}
    </Box>
  </Box>
);

ProjectVision.defaultProps = {
  reverse: false,
};

export default ProjectVision;
